import React, { useEffect, useState, useContext } from "react";
import Grid from "@mui/material/Grid";
import OndemandVideo from "@mui/icons-material/OndemandVideo";
import SupervisorAccount from "@mui/icons-material/SupervisorAccount";
import CollectionsBookmark from "@mui/icons-material/CollectionsBookmark";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import GroupIcon from "@mui/icons-material/Group";
import StarRateIcon from "@mui/icons-material/StarRate";
import AppsIcon from "@mui/icons-material/Apps";
import Edit from "@mui/icons-material/Edit";
import colorfull from "dan-api/palette/colorfull";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import CounterWidget from "../Counter/CounterWidget";
import useStyles from "./widget-jss";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";
import MainContext from "../../Services/Context/MainContext";
import Services from "../../Services/Services";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import ArticleIcon from "@mui/icons-material/Article";

function CounterIconsWidget({ redirect_url }) {
  const { classes } = useStyles();

  const [dashboardCountList, setDashboardCountList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await Services.getEachTotalCountForDashboard();

        setDashboardCountList(res.data);
      } catch (err) {
        console.log("err", err);
      }
    };
    fetchData();
  }, []);

  return (
    <div className={classes.rootCounterFull}>
      <Grid container spacing={2}>
        <Grid item xs={6} md={4} lg={3}>
          <NavLink to={`/${redirect_url}/userlists`}>
            <CounterWidget
              color={colorfull[12]}
              start={0}
              // start={loading ? { loader } : getAllUserLength}
              end={dashboardCountList?.total_users}
              duration={3}
              title="Total Users"
            >
              {/* <OndemandVideo className={classes.counterIcon} /> */}
              <SupervisorAccount
                style={{ color: colorfull[12] }}
                className={classes.counterIcon}
              />
            </CounterWidget>
          </NavLink>
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <NavLink to={`/${redirect_url}/services-programms`}>
            <CounterWidget
              color={colorfull[17]}
              start={0}
              end={dashboardCountList?.total_services}
              duration={3}
              title="Total Services & Programmes"
            >
              <AppsIcon
                style={{ color: colorfull[17] }}
                className={classes.counterIcon}
              />
            </CounterWidget>
          </NavLink>
        </Grid>
        {/* <Grid item xs={6} md={4} lg={3}>
     
          <CounterWidget
            color={colorfull[14]}
            start={0}
            end={getRewardCount + getReferralPoints}
            duration={3}
            title="Total Achieved Points"
          >
            <StarRateIcon className={classes.counterIcon} />
          </CounterWidget>
     
        </Grid> */}
        <Grid item xs={6} md={4} lg={3}>
          <NavLink to={`/${redirect_url}/institutes`}>
            <CounterWidget
              color={colorfull[15]}
              start={0}
              end={dashboardCountList?.total_institutes}
              duration={3}
              title="Total Institutes"
            >
              <AccountBalanceIcon
                style={{ color: colorfull[15] }}
                className={classes.counterIcon}
              />
            </CounterWidget>
          </NavLink>
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <NavLink to={`/${redirect_url}/institutes`}>
            <CounterWidget
              color={colorfull[10]}
              start={0}
              end={dashboardCountList?.total_coordinator}
              duration={3}
              title="Total Institute Coordinators"
            >
              <SupervisorAccount
                style={{ color: colorfull[10] }}
                className={classes.counterIcon}
              />
            </CounterWidget>
          </NavLink>
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <NavLink to={`/${redirect_url}/eventsManagement`}>
            <CounterWidget
              color={colorfull[18]}
              start={0}
              end={dashboardCountList?.total_events}
              duration={3}
              title="Total Events"
            >
              <EventAvailableIcon
                style={{ color: colorfull[18] }}
                className={classes.counterIcon}
              />
            </CounterWidget>
          </NavLink>
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <NavLink to={`/${redirect_url}/eventsManagement`}>
            <CounterWidget
              color={colorfull[19]}
              start={0}
              end={dashboardCountList?.total_registered_user}
              duration={3}
              title="Total Registered Participants"
            >
              <GroupIcon
                style={{ color: colorfull[19] }}
                className={classes.counterIcon}
              />
            </CounterWidget>
          </NavLink>
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <NavLink
            // to={`/${redirect_url}/news-articles/all`}
            to={{
              pathname: `/${redirect_url}/news-articles/all`,
              state: { defaultTabId: 0 },
            }}
          >
            <CounterWidget
              color="#FF5733"
              start={0}
              end={dashboardCountList?.total_news}
              duration={3}
              title="Total News"
            >
              <NewspaperIcon
                style={{ color: "#FF5733" }}
                className={classes.counterIcon}
              />
            </CounterWidget>
          </NavLink>
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <NavLink
            to={{
              pathname: `/${redirect_url}/news-articles/all`,
              state: { defaultTabId: 1 },
            }}
          >
            <CounterWidget
              color="#673AB7"
              start={0}
              end={dashboardCountList?.total_article}
              duration={3}
              title="Total Articles"
            >
              <ArticleIcon
                style={{ color: "#673AB7" }}
                className={classes.counterIcon}
              />
            </CounterWidget>
          </NavLink>
        </Grid>
      </Grid>
    </div>
  );
}

export default CounterIconsWidget;
